/** Shared capability token for /display/:token (same value in dev and prod builds). */
export const DISPLAY_ACCESS_TOKEN =
	(import.meta.env.VITE_DISPLAY_ACCESS_TOKEN || '').trim();

const DEVICE_STORAGE_KEY = 'gatesnow-display-device-id';

export const isDisplayPath = (pathname = '') =>
	pathname === '/display' || pathname.startsWith('/display/');

export const parseDisplayToken = (pathname = '') => {
	const parts = pathname.split('/').filter(Boolean);
	// /display/:token[/map|/table]
	if (parts[0] !== 'display' || parts.length < 2) return null;
	return parts[1] || null;
};

export const isValidDisplayToken = (token) =>
	Boolean(DISPLAY_ACCESS_TOKEN) &&
	Boolean(token) &&
	token === DISPLAY_ACCESS_TOKEN;

export const displayBasePath = () =>
	DISPLAY_ACCESS_TOKEN ? `/display/${DISPLAY_ACCESS_TOKEN}` : '/display';

export const getOrCreateDisplayDeviceId = () => {
	try {
		const existing = localStorage.getItem(DEVICE_STORAGE_KEY);
		if (existing && existing.length >= 16) return existing;
		const id =
			typeof crypto !== 'undefined' && crypto.randomUUID
				? crypto.randomUUID()
				: `d-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
		localStorage.setItem(DEVICE_STORAGE_KEY, id);
		return id;
	} catch {
		return `d-session-${Date.now()}`;
	}
};
